var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog-nav-btn",on:{"click":function($event){return _vm.sideMenu('catalog')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }